import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import PinterestIcon from '@material-ui/icons/Pinterest';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

const useStyles = makeStyles(theme => ({
  icon: {
    fill: '#fff',
    width: theme.spacing(5),
    height: theme.spacing(5)
  }
}));

export default (props) => {
  const classes = useStyles();
  return (
    <Grid container direction="row" justify="flex-start" spacing={1}>
      { props.config && props.config.facebookUrl &&
        <Grid item><a href={props.config.facebookUrl} target="_blank" rel="noopener noreferrer"><FacebookIcon className={classes.icon} /></a></Grid>
      }
      { props.config && props.config.twitterUrl &&
        <Grid item><a href={props.config.twitterUrl} target="_blank" rel="noopener noreferrer"><TwitterIcon className={classes.icon} /></a></Grid>
      }
      { props.config && props.config.youtubeUrl &&
        <Grid item><a href={props.config.youtubeUrl} target="_blank" rel="noopener noreferrer"><YouTubeIcon className={classes.icon} /></a></Grid>
      }
      { props.config && props.config.instagramUrl &&
        <Grid item><a href={props.config.instagramUrl} target="_blank" rel="noopener noreferrer"><InstagramIcon className={classes.icon} /></a></Grid>
      }
      { props.config && props.config.pinterestUrl &&
        <Grid item><a href={props.config.pinterestUrl} target="_blank" rel="noopener noreferrer"><PinterestIcon className={classes.icon} /></a></Grid>
      }
      { props.config && props.config.linkedinUrl &&
        <Grid item><a href={props.config.linkedinUrl} target="_blank" rel="noopener noreferrer"><LinkedInIcon className={classes.icon} /></a></Grid>
      }
    </Grid>
  );
}
